import React, { Component } from 'react';
import AppMenu from './AppMenu';

class AppMenuContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      openAdminMenu: false,
      openUpdateMenu: false,
    };

    this._onToggleMenu = this._onToggleMenu.bind(this);
    this._onClickMenuItem = this._onClickMenuItem.bind(this);
    this._onToggleAdminMenu = this._onToggleAdminMenu.bind(this);
    this._onToggleUpdateMenu = this._onToggleUpdateMenu.bind(this);
  }

  render() {
    return (
      <AppMenu
        open={this.state.open}
        onToggleMenu={this._onToggleMenu}
        onClickMenuItem={this._onClickMenuItem}
        onToggleAdminMenu={this._onToggleAdminMenu}
        onToggleUpdateMenu={this._onToggleUpdateMenu}
        openAdminMenu={this.state.openAdminMenu}
        openUpdateMenu={this.state.openUpdateMenu}
      />
    );
  }

  _onToggleMenu() {
    this.setState({ open: !this.state.open });
  }

  _onClickMenuItem(cb) {
    this.setState({ open: false }, () => {
      if (typeof cb === 'function') {
        cb();
      }
    });
  }

  _onToggleAdminMenu() {
    this.setState({ openAdminMenu: !this.state.openAdminMenu });
  }

  _onToggleUpdateMenu() {
    this.setState({ openUpdateMenu: !this.state.openUpdateMenu });
  }
}

export default AppMenuContainer;
